import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.css'
import App from './App.tsx'
import { ErrorBoundary } from './components/providers/ErrorBoundary'
import { ToastProvider } from './components/providers/ToastProvider'
import { AuthProvider } from './components/providers/AuthProvider'
import { LogRocketProvider } from './components/providers/LogRocketProvider'
import { ActivityTrackerProvider } from './components/providers/ActivityTrackerProvider'
import { RecoveryProvider } from './components/providers/RecoveryProvider'

// Service worker registration is handled by VitePWA (`injectRegister: 'auto'`).
// NOTE: We intentionally do NOT auto-reload on `controllerchange` because iOS Safari/PWA
// can trigger repeated controller swaps after long sleep, causing reload loops/crashes.

if (import.meta.env.VITE_DEMO_MODE === 'true') {
  const { installDemoMocks } = await import('./demo')
  installDemoMocks()
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <LogRocketProvider>
            <ActivityTrackerProvider>
              <RecoveryProvider>
                <App />
              </RecoveryProvider>
            </ActivityTrackerProvider>
          </LogRocketProvider>
        </AuthProvider>
      </ToastProvider>
    </ErrorBoundary>
  </StrictMode>,
)
